import React from 'react';
import { Button, Menu, MenuItem, styled, TableCell } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Purchase } from 'src/dto/Credits';
import ButtonComponent from 'src/components/ButtonComponent';

const TransparentButton = styled(Button)(() => ({
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

interface Props {
  model: Purchase;
  onEdit: (purchase: Purchase) => void;
  onDelete: (purchase: Purchase) => void;
}

export const Actions: React.FC<Props> = ({ model, onEdit, onDelete }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleOpen = (event: { currentTarget: React.SetStateAction<HTMLElement | null> }) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <TableCell>
      <ButtonComponent icon={<MoreHorizIcon />} buttontype="icon" onClick={handleOpen} data-testid="actions-button" />

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => onEdit(model)}>
          <TransparentButton variant="text" color="inherit" startIcon={<EditIcon />} disableRipple>
            Edit
          </TransparentButton>
        </MenuItem>

        <MenuItem onClick={() => onDelete(model)}>
          <TransparentButton variant="text" color="inherit" startIcon={<DeleteIcon />} disableRipple>
            Delete
          </TransparentButton>
        </MenuItem>
      </Menu>
    </TableCell>
  );
};
